import { ApplicationConfig } from '@angular/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename';
import { APOLLO_OPTIONS, Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApiRoutes } from 'src/app/repositories/apiRoutes';

const removeTypenameLink = removeTypenameFromVariables();

export function createApollo(httpLink: HttpLink) {
    const uri = `${ApiRoutes.getBackendBaseUrl()}/graphql`;
    const link = ApolloLink.from([removeTypenameLink, httpLink.create({ uri })]);
    const cache = new InMemoryCache();

    return {
        link,
        cache,
    };
}
export const graphqlProvider: ApplicationConfig['providers'] = [
    Apollo,
    {
        provide: APOLLO_OPTIONS,
        useFactory: createApollo,
        deps: [HttpLink],
    },
];
